import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import Header from '../components/molecule/Header';
import Wrapper from '../components/atoms/Wrapper';
import Headline from '../components/atoms/Headline';
import Copy from '../components/atoms/Copy';
import Footer from '../components/molecule/Footer';

const StyledHeadline = styled(Headline)`
  margin-bottom: var(--distance-s);
`;

const ConstructionPage = () => {
  const { t, i18n } = useTranslation();
  return (
    <>
      <Header disableLogo={true} />
      <Wrapper>
        <StyledHeadline forwardedAs="h1" label={t('construction.headline')} />
        <Copy as="p">{t('construction.copy')}</Copy>
      </Wrapper>
      <Footer taglineOnly={true} />
    </>
  );
};

export default ConstructionPage;
